import createReducer from '../../helpers/createReducer'
import t from '../../helpers/translate'
import * as actions from './actions'

export const CONFIRM_DIALOG_STATE = 'confirmDialog'
export const defaultState = {
  open: false,
  title: t('Delete confirmation'),
  message: t('Are you sure to delete this item?'),
  onConfirm: () => {}
}

const reducer = () => {
  return createReducer(defaultState, {
    [`${actions.CONFIRM_DIALOG_OPEN}`] (state, { payload }) {
      return {
        ...state,
        ...payload,
        open: true
      }
    },

    [`${actions.CONFIRM_DIALOG_CLOSE}`] (state) {
      return {
        ...defaultState,
        open: false
      }
    }
  })
}

export default reducer
